import { ref, onUnmounted } from 'vue'
import { useQrScannerGlobal } from './useQrScannerGlobal'

export type OnScanCallback = (code: string) => void

export function useQrScanner () {
  const qrScannerGlobal = useQrScannerGlobal()

  const onScanCallbacks = ref<OnScanCallback[]>([])
  function onScan (callback: OnScanCallback) {
    onScanCallbacks.value.push(callback)
  }

  async function scan (injectedRaw?: string) {
    try {
      await qrScannerGlobal.scan(injectedRaw)
      console.log('scan result: ', qrScannerGlobal.result.value)
      console.log('discovered code: ', qrScannerGlobal.qrCode.value)
    } catch (error) {
      console.error(error)
      return
    }

    onScanCallbacks.value.forEach(callback => {
      callback(qrScannerGlobal.result.value)
    })
  }

  onUnmounted(() => {
    onScanCallbacks.value = []
  })

  return {
    ...qrScannerGlobal,
    scan,
    onScan,
    onScanCallbacks,
  }
}
